module.exports = __webpack_public_path__ + "media/images/product/c_c-0d03c03b9c59f065a7e2724c1a838388.jpg";